import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-genmo-color-large.tsx
/**
* icon.24.logo.genmo.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iIzVmOTZmNCIgZD0iTTMgMTAuODI1YzAtLjQwMy4zNy0uNzA0Ljc2NS0uNjIybDcuNDk5IDEuNTdjLjQ5LjEwMi44NDIuNTM1Ljg0MiAxLjAzNnY3LjE0NmEuNjM2LjYzNiAwIDAgMS0uNzY2LjYyMmwtNy40OTgtMS41N0ExLjA2IDEuMDYgMCAwIDEgMyAxNy45NzF6Ii8+PHBhdGggZmlsbD0iI2Y4YmY0NiIgZD0iTTcuNDQ3IDcuNDM4YzAtLjQwMy4zNy0uNzA0Ljc2NS0uNjIybDcuNDk5IDEuNTdjLjQ5LjEwMy44NDIuNTM1Ljg0MiAxLjAzNnY3LjE0NmEuNjM2LjYzNiAwIDAgMS0uNzY2LjYyMkw4LjI5IDE1LjYyYTEuMDYgMS4wNiAwIDAgMS0uODQyLTEuMDM2eiIvPjxwYXRoIGZpbGw9IiM1OTg0ZDAiIGQ9Ik0xMS4yNjQgMTEuNzcyYy40OS4xMDIuODQyLjUzNS44NDIgMS4wMzZ2My42MDdsLTMuODE3LS43OTlhMS4wNiAxLjA2IDAgMCAxLS44NDItMS4wMzZ2LTMuNjA3eiIvPjxwYXRoIGZpbGw9IiNlYjUzNzIiIGQ9Ik0xMS44OTQgNC4wNDRjMC0uNDAzLjM3MS0uNzA1Ljc2Ni0uNjIybDcuNDk4IDEuNTdjLjQ5LjEwMi44NDIuNTM1Ljg0MiAxLjAzNnY3LjE0NmMwIC40MDMtLjM3LjcwNC0uNzY1LjYyMmwtNy40OTktMS41N2ExLjA2IDEuMDYgMCAwIDEtLjg0Mi0xLjAzNnoiLz48cGF0aCBmaWxsPSIjZjY5YTI2IiBkPSJNMTUuNzEgOC4zODZjLjQ5MS4xMDIuODQyLjUzNS44NDIgMS4wMzZ2My42MDFsLTMuODE2LS43OThhMS4wNiAxLjA2IDAgMCAxLS44NDItMS4wMzdWNy41ODZ6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11281
*/
const Icon24LogoGenmoColorLarge = memo(function Icon24LogoGenmoColorLarge(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#5f96f4",
				d: "M3 10.825c0-.403.37-.704.765-.622l7.499 1.57c.49.102.842.535.842 1.036v7.146a.636.636 0 0 1-.766.622l-7.498-1.57A1.06 1.06 0 0 1 3 17.971z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#f8bf46",
				d: "M7.447 7.438c0-.403.37-.704.765-.622l7.499 1.57c.49.103.842.535.842 1.036v7.146a.636.636 0 0 1-.766.622L8.29 15.62a1.06 1.06 0 0 1-.842-1.036z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#5984d0",
				d: "M11.264 11.772c.49.102.842.535.842 1.036v3.607l-3.817-.799a1.06 1.06 0 0 1-.842-1.036v-3.607z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#eb5372",
				d: "M11.894 4.044c0-.403.371-.705.766-.622l7.498 1.57c.49.102.842.535.842 1.036v7.146c0 .403-.37.704-.765.622l-7.499-1.57a1.06 1.06 0 0 1-.842-1.036z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#f69a26",
				d: "M15.71 8.386c.491.102.842.535.842 1.036v3.601l-3.816-.798a1.06 1.06 0 0 1-.842-1.037V7.586z"
			})
		]
	});
});
//#endregion
export { Icon24LogoGenmoColorLarge };

//# sourceMappingURL=icon-24-logo-genmo-color-large.js.map